export default __webpack_public_path__ + "static/media/xueshengma-bg.c2a29bb1.png";